export default "__VITE_ASSET__DEFEpPFb__"